// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3rl6_","range":"MonthRangeSwitch_range__2x_ZP","disabled":"MonthRangeSwitch_disabled__mw9aF"};